import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import { Heading } from '@warrenbrasil/nebraska-web';
import { CardCounter } from '@/modules/common/components/cards/CardCounter';

import {
  IHomeButtonsV2,
  getButtonsV2,
  EButtonTypeV2,
  getButtonsV3,
  IHomeButtonsV3,
  EButtonTypeV3
} from '@/modules/home/services/consolidation';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';
import { FeatureFlags } from '@/types/models/FeatureFlags';

interface Emits {
  (event: 'open-register-panel'): void;
  (event: 'open-orders-panel', type: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeActivities',
  emits: ["open-register-panel", "open-orders-panel"],
  setup(__props, { emit }: { emit: ({
  (event: 'open-register-panel'): void;
  (event: 'open-orders-panel', type: string): void;
}), expose: any, slots: any, attrs: any }) {

const router = useRouter();



const isLoading = ref(true);
const homeButtons = ref<IHomeButtonsV2 | IHomeButtonsV3 | void>();

const isEnabledPortabilityExitMenuItem = computed(() => {
  return FeatureFlagsModule.isEnabled(FeatureFlags.PORTABILITY_EXIT_MENU_ITEM);
});

async function fetchButtons() {
  try {
    isLoading.value = true;

    if (isEnabledPortabilityExitMenuItem.value) {
      homeButtons.value = await getButtonsV3();
    } else {
      homeButtons.value = await getButtonsV2();
    }
  } finally {
    isLoading.value = false;
  }
}

function handleClick(type: EButtonTypeV2 | EButtonTypeV3) {
  if (isEnabledPortabilityExitMenuItem.value) {
    if (Object.values(EButtonTypeV3).includes(type as EButtonTypeV3)) {
      switch (type) {
        case EButtonTypeV3.APPROVALS:
          router.push({ name: 'investmentSuggestions' });
          break;
        case EButtonTypeV3.REGISTER:
          emit('open-register-panel');
          break;
        case EButtonTypeV3.INVESTMENT:
          emit('open-orders-panel', type);
          break;
        case EButtonTypeV3.REDEMPTION:
          emit('open-orders-panel', type);
          break;
        case EButtonTypeV3.PORTABILITY_REQUESTS:
          window.location.assign('/products/#/portability/requests');
          break;
        case EButtonTypeV3.PORTABILITY_IN_PROGRESS:
          window.location.assign('/products/#/portability');
          break;
        default:
          break;
      }
      return;
    }
  }

  if (Object.values(EButtonTypeV2).includes(type as EButtonTypeV2)) {
    switch (type) {
      case EButtonTypeV2.IN_PORTABILITY:
        window.location.assign('/products/#/portability');
        break;
      case EButtonTypeV2.OUT_PORTABILITY:
        router.push({ name: 'portabilityRequests' });
        break;
      case EButtonTypeV2.REQUESTS_PORTABILITY:
        window.location.assign('/products/#/portability/requests');
        break;
      case EButtonTypeV2.APPROVALS:
        router.push({ name: 'investmentSuggestions' });
        break;
      case EButtonTypeV2.REGISTER:
        emit('open-register-panel');
        break;
      case EButtonTypeV2.INVESTMENT:
        emit('open-orders-panel', type);
        break;
      case EButtonTypeV2.REDEMPTION:
        emit('open-orders-panel', type);
        break;
      default:
        break;
    }
  }
}

onMounted(fetchButtons);

return { __sfc: true,router, emit, isLoading, homeButtons, isEnabledPortabilityExitMenuItem, fetchButtons, handleClick, Heading, CardCounter }
}

})